import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";
import { admitCreator } from "@/features/coworlds/records";
import { VerifiedViewer } from "@/session/product-session";

export const Route = createFileRoute("/_site/coworlds/$name/runs")({
  beforeLoad: ({ matches, routeId }) => {
    if (matches.at(-1)?.routeId === routeId) throw notFound();
  },
  loader: () => admitCreator(),
  component: function CreatorRunsPage() {
    const creatorViewer = Route.useLoaderData();
    return (
      <VerifiedViewer viewer={creatorViewer}>
        <Outlet />
      </VerifiedViewer>
    );
  },
});
